import axios from 'axios';

export const getAxiosClient = (baseURL, timeout=30000) => {
    const axiosInstance = axios.create({
        baseURL,
        timeout,
    });

    return axiosInstance;
}
